import React from "react";
import moment from "moment";
import { useNavigate, Link, useParams } from "react-router-dom";
import {
  TailwindToaster,
  ConfirmationModal,
  TaskCompletePopup,
} from "../../components";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { FileUploader } from "react-drag-drop-files";
import { format } from "date-fns";
import CryptoJS from "crypto-js";
import axios from "../../api/axios";
import { downloadBlobFile, uploadBlobToContainer } from "../../api/azure";

const ServiceTicketViewSpecific = () => {
  moment.locale("en-US");
  const state = useSelector((state) => state.UserReducer);
  const serviceTaskUrl = "/servicetask/";
  const checklistUrl = "/taskchecklist";
  const activeUsersUrl = "/user/active";
  const taskCommentsUrl = "/taskcomment";
  const navigate = useNavigate();
  const { serviceTaskId } = useParams();
  const taskDueDate = moment().format("yyyy-MM-DD");
  const blobContainerName = "servicetaskattachments";

  const [validChecklistName, setChecklistNameValidity] = React.useState(true);
  const [completeCheckPointId, setCompleteCheckPointId] = React.useState(null);
  const [requestLoading, setRequestLoading] = React.useState(false);
  const [isFileUploading, setIsFileUploading] = React.useState(false);

  const [refreshData, setRefreshData] = React.useState(0);
  const [serviceTaskData, setServiceTaskData] = React.useState({});
  const [serviceTicketData, setServiceTicketData] = React.useState({});
  const [taskCommentsData, setTaskCommentsData] = React.useState([]);
  const [taskChecklistData, setTaskChecklistData] = React.useState([]);
  const [assigneeData, setAssigneeData] = React.useState([]);
  const [validTaskName, setTaskNameValidity] = React.useState(true);
  const [validServiceTicket, setServiceTicketValidity] = React.useState(true);

  const renderStatus = (status) => {
    switch (status) {
      case "NEW":
        return (
          <span className='bg-blue-100 text-blue-800 text-sm font-semibold px-2.5 py-0.5 rounded dark:bg-blue-200 dark:text-blue-800'>
            NEW
          </span>
        );
      case "ASSIGNED":
        return (
          <span className='bg-orange-100 text-orange-800 text-sm font-semibold px-2.5 py-0.5 rounded dark:bg-orange-200 dark:text-orange-900'>
            ASSIGNED
          </span>
        );
      case "IN-PROCESS":
        return (
          <span className='bg-green-100 text-green-800 text-sm font-semibold px-2.5 py-0.5 rounded dark:bg-green-200 dark:text-green-900'>
            IN-PROCESS
          </span>
        );
      case "DONE":
        return (
          <span className='bg-green-100 text-green-800 text-sm font-semibold px-2.5 py-0.5 rounded dark:bg-green-200 dark:text-green-900'>
            DONE
          </span>
        );
      default:
        return (
          <span className='bg-red-100 text-red-600 text-sm font-semibold px-2.5 py-0.5 rounded dark:bg-red-200 dark:text-red-900'>
            {status}
          </span>
        );
    }
  };
  const renderTags = (tags) => {
    const tagsArray = tags.split(" ");
    var returnText = "";
    tagsArray.forEach((element) => {
      returnText += "#" + element + " ";
    });
    return returnText.trim();
  };

  const [showChecklistForm, setShowChecklistForm] = React.useState(false);
  const addChecklist = () => {
    const checklistName = document.getElementById("checklistName").value;
    if (checklistName === "") {
      setChecklistNameValidity(false);
      return;
    } else {
      setChecklistNameValidity(true);
      setRequestLoading(true);
      try {
        axios
          .post(
            checklistUrl,
            JSON.stringify({ taskId: serviceTaskId, name: checklistName }),
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: state.user.token,
              },
            },
          )
          .then((response) => {
            if (response?.data?.status === "success") {
              toast.success(response.data.message);
              setShowChecklistForm(false);
              document.getElementById("checklistName").value = "";
              setRefreshData(refreshData + 1);
            } else {
              toast.error(response.data.message);
            }
          });
      } catch (err) {
        toast.error("Something went wrong");
        console.log(err);
      } finally {
        setRequestLoading(false);
      }
    }
  };

  const markCheckpointComplete = (checklistId) => {
    try {
      axios
        .put(
          checklistUrl + "/" + checklistId,
          JSON.stringify({ completionPercentage: 100 }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: state.user.token,
            },
          },
        )
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response.data.message);
            setCompleteCheckPointId(null);
            setRefreshData(refreshData + 1);
          } else {
            toast.error(response.data.message);
          }
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const getAssigneeOptions = () => {
    try {
      axios
        .get(activeUsersUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.users?.length > 0) {
            setAssigneeData(response.data.users);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const getServiceTaskDetails = () => {
    try {
      axios
        .get(serviceTaskUrl + serviceTaskId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.serviceTask) {
            setServiceTaskData(response.data.serviceTask);
            setServiceTicketData(response.data.serviceTicket);
            setTaskCommentsData(response.data.taskComments);
            setTaskChecklistData(response.data.taskChecklists);
            getAssigneeOptions();
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [validCommentDescription, setCommentDescriptionValidity] =
    React.useState(true);
  const [commentAttachments, setCommentAttachments] = React.useState([]);

  const uploadCommentAttachments = async (files) => {
    setIsFileUploading(true);
    let latestAttachments = [];
    for (let i = 0; i < files.length; i++) {
      const fileExtension = files[i].name.split(".")[1];
      const blobName =
        CryptoJS.AES.encrypt(
          files[i].name + Date.now().toString(),
          process.env.REACT_APP_CIPHER_CODE,
        )
          .toString()
          .replace(/[^a-zA-Z0-9_]/g, "") + ".crypt";
      // + fileExtension;
      try {
        const uploadBlobResult = await uploadBlobToContainer(
          blobContainerName,
          blobName,
          files[i],
        );
        if (uploadBlobResult.status === "success") {
          const blobItem = {
            originalname: files[i].name,
            size: files[i].size,
            blobContainer: blobContainerName,
            blobName,
            mimetype: files[i].type,
          };
          latestAttachments.push(blobItem);
        }
      } catch (err) {
        toast.error("Something went wrong");
        console.log(err);
      }
    }
    if (commentAttachments.length > 0)
      setCommentAttachments(commentAttachments.concat(latestAttachments));
    else setCommentAttachments(latestAttachments);
    setIsFileUploading(false);
  };

  const removeCommentAttachment = (serverfilename) => {
    const filteredAttachments = commentAttachments.filter((item) => {
      return item.originalname !== serverfilename;
    });
    setCommentAttachments(filteredAttachments);
  };

  const [popupId, setPopupId] = React.useState(null);
  const removeActivity = (taskCommentId) => {
    setPopupId(taskCommentId);
  };

  const closeConfirmation = () => {
    setPopupId(null);
  };
  const popupCallback = (canProceed) => {
    if (canProceed) removeActivityServer(popupId);
    setPopupId(null);
  };

  const removeActivityServer = (taskCommentId) => {
    try {
      axios
        .delete(taskCommentsUrl + "/" + taskCommentId, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response?.data?.message);
            setRefreshData(refreshData + 1);
          } else toast.error(response?.data?.message);
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };
  const postComment = (event) => {
    var canSubmit = true;
    const taskCommentData = new FormData(event.target);

    setCommentDescriptionValidity(true);

    if (taskCommentData.get("commentDescription") === "") {
      setCommentDescriptionValidity(false);
      canSubmit = false;
    }

    if (!canSubmit) {
      return;
    }
    setRequestLoading(true);
    const dataToSubmit = {
      taskId: serviceTaskId,
      description: taskCommentData.get("commentDescription"),
      tags: taskCommentData.get("commentTags"),
      commentAttachments,
    };
    try {
      axios
        .post(taskCommentsUrl, JSON.stringify(dataToSubmit), {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response.data.message);
            document.getElementById("taskCommentForm").reset();
            setCommentAttachments([]);
            // setRefreshData(refreshData + 1);
            setTaskCommentsData(response.data.taskComments);
            setCompletePopupVisible(true);
          } else {
            toast.error(response.data.message);
          }
        })
        .catch((err) => {
          toast.error(err.message);
        });
    } catch (err) {
      console.log(err);
      toast.error(err.message);
    } finally {
      setRequestLoading(false);
    }
  };

  const [downloadBlobFileName, setDownloadBlobFile] = React.useState(null);

  const downloadAttachment = async (
    blobContainer,
    blobName,
    originalname,
    mimetype,
  ) => {
    try {
      setDownloadBlobFile(blobName);
      const azureDownloadresult = await downloadBlobFile(
        blobContainer,
        blobName,
        originalname,
      );
      if (azureDownloadresult.status === "success") {
        const azureData = azureDownloadresult.data;
        const downloadFileUrl = window.URL.createObjectURL(azureData);
        const temporaryDownloadLink = document.createElement("a");
        temporaryDownloadLink.href = downloadFileUrl;
        temporaryDownloadLink.setAttribute("download", originalname);
        temporaryDownloadLink.click();
      } else {
        toast.error("Something went wrong with file download");
      }
      setDownloadBlobFile(null);
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [editComponent, setEditComponent] = React.useState("");

  const updateDetails = (name, value, splflag = false) => {
    setEditComponent("");
    const dataToSubmit = {};
    var targetValue = value;
    if (!splflag) targetValue = document.getElementById(value).value;
    if (name === "assignee" && serviceTaskData.assignee._id === targetValue) {
      return;
    } else if (serviceTaskData[name] === targetValue) {
      return;
    }

    if (name === "name" && targetValue !== "") dataToSubmit.name = targetValue;
    else if (name === "dueDate" && targetValue !== "")
      dataToSubmit.dueDate = targetValue;
    else if (name === "status" && targetValue !== "")
      dataToSubmit.status = targetValue;
    else if (name === "description") dataToSubmit.description = targetValue;
    else if (name === "assignee" && targetValue !== "")
      dataToSubmit.assignee = targetValue;

    if (Object.keys(dataToSubmit).length <= 0) {
      return;
    }

    try {
      axios
        .put(serviceTaskUrl + serviceTaskId, JSON.stringify(dataToSubmit), {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response.data.message);
            setRefreshData(refreshData + 1);
          } else {
            toast.error(response.data.message);
          }
        })
        .catch((err) => {
          toast.error(err.message);
        });
    } catch (err) {
      console.log(err);
      toast.error(err.message);
    } finally {
      setRequestLoading(false);
    }
  };

  const [completePopupVisible, setCompletePopupVisible] = React.useState(false);

  const closeCompletedPopup = () => {
    setCompletePopupVisible(false);
  };

  const completeTask = (canProceed) => {
    if (canProceed) updateDetails("status", "DONE", true);
    setCompletePopupVisible(true);
  };

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    getServiceTaskDetails();
  }, [refreshData]);

  return (
    <>
      {completePopupVisible && (
        <TaskCompletePopup
          completeConfirmation={completeTask}
          closeCompletedPopup={closeCompletedPopup}
        />
      )}
      {popupId && (
        <ConfirmationModal
          actionName={<strong>Delete Activity</strong>}
          deleteConfirmation={popupCallback}
          moduleName={"Delete Activity (irreversible)"}
          itemName={"of Task"}
          closeConfirmation={closeConfirmation}
        />
      )}
      <div className='min-h-full'>
        <main className='relative'>
          <div className='max-w-8xl mx-auto py-6 sm:px-6 lg:px-8'>
            <div className='px-4 py-0 sm:px-0'>
              <div className='block'>
                <TailwindToaster />
                <div className='overflow-hidden sm:rounded-md'>
                  <div className='flex-col sm:flex'>
                    <div className='px-4 py-5 bg-gray-50 sm:p-6 sm:w-9/12 w-full'>
                      <div className='flex justify-between'>
                        <div className='flex-1 min-w-0 px-0 lg:px-0'>
                          <h2 className='text-lg font-semibold leading-3 text-gray-dark sm:text-xl '>
                            Service Task Details - #
                            {serviceTaskData.serviceTaskID}
                          </h2>
                        </div>
                      </div>
                      <div className='mt-4 sm:mt-4 grid grid-cols-12 gap-6'>
                        <div className='col-span-12 sm:col-span-4'>
                          <label
                            className={`block text-sm font-medium text-gray-700`}>
                            Service Ticket
                          </label>
                          {serviceTaskData?._id ? (
                            serviceTicketData?._id ? (
                              <span className='mt-1 ml-2 block w-full py-0 sm:text-base'>
                                <div className='flex justify-start h-full justify-left  '>
                                  <div
                                    onClick={(e) => {
                                      navigate(
                                        "/serviceticket/" +
                                          serviceTicketData._id,
                                      );
                                    }}
                                    className='font-semibold text-sm text-yellow-dark cursor-pointer py-1 px-3 rounded-sm bg-gray-50 hover:bg-gray-dark hover:text-white duration-200'>
                                    {"#" +
                                      serviceTicketData.serviceTicketID +
                                      " | " +
                                      serviceTicketData.addressBookId?.prefix +
                                      ". " +
                                      serviceTicketData.addressBookId
                                        ?.firstName +
                                      (serviceTicketData.serviceTypeId
                                        ? " | " +
                                          serviceTicketData.serviceTypeId.name +
                                          " > " +
                                          (serviceTicketData.subServiceTypeId
                                            ? serviceTicketData.subServiceTypeId
                                                .name
                                            : "")
                                        : "")}
                                  </div>
                                </div>
                              </span>
                            ) : (
                              <span className='mt-0 ml-2 flex w-full py-0 sm:text-base'>
                                <div className='font-semibold text-sm py-1 pt-0 rounded-md leading-5'>
                                  --
                                </div>
                              </span>
                            )
                          ) : (
                            <span className='mt-1 block w-full py-0 sm:text-base'>
                              <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                                <div className='w-56 bg-gray-100 h-6 rounded-md '></div>
                              </div>
                            </span>
                          )}
                        </div>
                        <div className='col-span-12 sm:col-span-8'>
                          <label
                            htmlFor='taskName'
                            className={`block text-sm font-medium ${
                              !validTaskName ? "text-red-600" : "text-gray-700"
                            }`}>
                            Task Name
                          </label>
                          {serviceTaskData?._id ? (
                            editComponent === "taskName" ? (
                              <input
                                type='text'
                                name='taskName'
                                id='taskName'
                                maxLength='150'
                                defaultValue={serviceTaskData.name}
                                onBlur={(e) => {
                                  updateDetails("name", "taskName");
                                }}
                                className={`mt-1 ${
                                  !validTaskName
                                    ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                    : "focus:ring-yellow-2 focus:border-yellow-2 w-9/12"
                                }  block w-full shadow-sm sm:text-sm  rounded-md`}
                              />
                            ) : (
                              <span className='mt-0 ml-2 flex w-full py-0 sm:text-base'>
                                <div className='justify-start h-full justify-left peer'>
                                  <div className='font-semibold text-sm py-1 pt-0 rounded-md leading-5'>
                                    {serviceTaskData.name}
                                  </div>
                                </div>
                                {serviceTaskData.createdBy._id ===
                                  state.user._id && (
                                  <div
                                    className='ml-0 opacity-0 peer-hover:opacity-100 hover:opacity-100 duration-300'
                                    onClick={(e) => {
                                      setEditComponent("taskName");
                                    }}>
                                    <svg
                                      xmlns='http://www.w3.org/2000/svg'
                                      className='h-6 w-6'
                                      viewBox='0 0 20 20'
                                      fill='currentColor'>
                                      <path d='M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z' />
                                    </svg>
                                  </div>
                                )}
                              </span>
                            )
                          ) : (
                            <span className='mt-1 block w-full py-0 sm:text-base'>
                              <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                                <div className='w-56 bg-gray-100 h-6 rounded-md '></div>
                              </div>
                            </span>
                          )}
                        </div>
                        <div className='col-span-6 sm:col-span-3'>
                          <label
                            htmlFor='taskDueDate'
                            className='block text-sm font-medium text-gray-700'>
                            Due Date
                          </label>
                          {serviceTaskData?._id ? (
                            editComponent === "taskDueDate" ? (
                              <input
                                type='datetime-local'
                                name='taskDueDate'
                                id='taskDueDate'
                                defaultValue={serviceTaskData.dueDate}
                                // onChange={(e) => {
                                //   updateDetails("dueDate", "taskDueDate");
                                // }}
                                onBlur={(e) => {
                                  if (editComponent !== "")
                                    updateDetails("dueDate", "taskDueDate");
                                }}
                                min={taskDueDate}
                                className='mt-1 focus:ring-yellow-2 focus:border-yellow-2 block w-full sm:w-9/12 shadow-sm sm:text-sm  rounded-md'
                              />
                            ) : (
                              <span className='mt-0 ml-2 flex w-full py-0 sm:text-base'>
                                <div className='flex justify-start h-full justify-left peer'>
                                  <div className='font-semibold text-sm py-1 pt-1  rounded-md leading-5'>
                                    {moment
                                      .utc(serviceTaskData.dueDate)
                                      // .local()
                                      .format("yyyy-MM-DD HH:mm")}
                                    {/* {moment
                                      .utc(
                                        serviceTaskData.dueDate,
                                        "yyyy-MM-ddTHH:mm:ss",
                                      )
                                      .tz("Asia/Kolkata")
                                      .format("yyyy-MM-dd hh:mm A")} */}
                                    {/* {serviceTaskData.dueDate
                                      ?.toString()
                                      .slice(0, 16)
                                      .replace("T", " ")} */}
                                  </div>
                                  {/* {serviceTaskData.dueDate
                                    .toString()
                                    .slice(0, 19)} */}

                                  {moment(
                                    serviceTaskData.dueDate
                                      .toString()
                                      .slice(0, 19),
                                  )
                                    // .local()
                                    .diff(Date.now(), "minutes") < 0 &&
                                    !serviceTaskData.status.includes(
                                      "DONE",
                                      "CANCELLED",
                                    ) && (
                                      <div className='font-semibold text-base pl-2 animate-pulse py-1 pt-2 rounded-md leading-5'>
                                        <span className='bg-red-100 text-red-600 text-xs font-semibold px-2.5 py-1 rounded dark:bg-red-200 dark:text-red-900'>
                                          OVERDUE
                                        </span>
                                      </div>
                                    )}
                                </div>
                                {serviceTaskData.createdBy._id ===
                                  state.user._id && (
                                  <div
                                    className='ml-1 mt-1 opacity-0 peer-hover:opacity-100 hover:opacity-100 duration-300'
                                    onClick={(e) => {
                                      setEditComponent("taskDueDate");
                                    }}>
                                    <svg
                                      xmlns='http://www.w3.org/2000/svg'
                                      className='h-6 w-6'
                                      viewBox='0 0 20 20'
                                      fill='currentColor'>
                                      <path d='M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z' />
                                    </svg>
                                  </div>
                                )}
                              </span>
                            )
                          ) : (
                            <span className='mt-1 block w-full py-0 sm:text-base'>
                              <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                                <div className='w-56 bg-gray-100 h-6 rounded-md '></div>
                              </div>
                            </span>
                          )}
                        </div>
                        <div className='col-span-6 sm:col-span-3'>
                          <label
                            htmlFor='assigneeId'
                            className='block text-sm font-medium text-gray-700'>
                            Assignee
                          </label>
                          {serviceTaskData?._id ? (
                            editComponent === "assigneeId" ? (
                              <>
                                <select
                                  id='assigneeId'
                                  name='assigneeId'
                                  defaultValue={serviceTaskData?.assignee?._id}
                                  onChange={(e) => {
                                    updateDetails("assignee", "assigneeId");
                                  }}
                                  onBlur={(e) => {
                                    if (editComponent !== "")
                                      updateDetails("assignee", "assigneeId");
                                  }}
                                  className='mt-1 block w-full py-2 px-3 border  bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                                  <option value=''>Unassigned</option>
                                  {assigneeData.length > 0 ? (
                                    assigneeData.map((item) => {
                                      return (
                                        <option
                                          key={item?._id}
                                          value={item?._id}>
                                          {item.fullname
                                            ? item.fullname
                                            : item.firstname}
                                        </option>
                                      );
                                    })
                                  ) : (
                                    <option key='1' value=''>
                                      Loading...
                                    </option>
                                  )}
                                </select>
                                <span
                                  className='block text-sm font-semibold text-yellow-2 cursor-pointer'
                                  onClick={(e) => {
                                    document.getElementById(
                                      "assigneeId",
                                    ).value = state.user._id;
                                  }}>
                                  Assign to me
                                </span>
                              </>
                            ) : (
                              <span className='mt-1 ml-2 flex w-full py-0 sm:text-base'>
                                <div className=' justify-start h-full justify-left peer'>
                                  <div className='font-semibold text-base py-0.5 px-2 bg-gray-100 rounded-md leading-5'>
                                    <div className='flex'>
                                      <div className='p-2 justify-between'>
                                        <img
                                          src={
                                            serviceTaskData?.assignee?.avatar
                                              ? serviceTaskData?.assignee
                                                  ?.avatar
                                              : "/assets/images/user.png"
                                          }
                                          alt='User'
                                          referrerPolicy='no-referrer'
                                          className='h-6 w-6 rounded-full ring-1 ring-yellow-2'
                                        />
                                      </div>
                                      <div className='flex flex-col p-2 pt-1'>
                                        <h2 className='font-semibold text-xs'>
                                          {serviceTaskData?.assignee?.fullname
                                            ? serviceTaskData?.assignee
                                                ?.fullname
                                            : serviceTaskData?.assignee
                                                ?.firstname}
                                        </h2>
                                        <h2 className='font-semibold text-xs'>
                                          {serviceTaskData?.assignee?.phone}
                                        </h2>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {serviceTaskData.createdBy._id ===
                                  state.user._id && (
                                  <div
                                    className='ml-1 mt-0 opacity-0 peer-hover:opacity-100 hover:opacity-100 duration-300'
                                    onClick={(e) => {
                                      setEditComponent("assigneeId");
                                    }}>
                                    <svg
                                      xmlns='http://www.w3.org/2000/svg'
                                      className='h-6 w-6'
                                      viewBox='0 0 20 20'
                                      fill='currentColor'>
                                      <path d='M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z' />
                                    </svg>
                                  </div>
                                )}
                              </span>
                            )
                          ) : (
                            <span className='mt-1 block w-full py-0 sm:text-base'>
                              <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                                <div className='w-56 bg-gray-100 h-6 rounded-md '></div>
                              </div>
                            </span>
                          )}
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='taskStatus'
                            className='block text-sm font-medium text-gray-700'>
                            Status
                          </label>
                          {serviceTaskData?._id ? (
                            editComponent === "taskStatus" ? (
                              <select
                                id='taskStatus'
                                name='taskStatus'
                                onChange={(e) => {
                                  updateDetails("status", "taskStatus");
                                }}
                                onBlur={(e) => {
                                  if (editComponent !== "")
                                    updateDetails("status", "taskStatus");
                                }}
                                defaultValue={serviceTaskData?.status}
                                className='mt-1 block w-full py-2 px-3 border  bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                                <option value=''>Select</option>
                                <option>ASSIGNED</option>
                                <option value='IN-PROCESS'>IN-PROCESS</option>
                                <option>DONE</option>
                                <option>CANCELLED</option>
                              </select>
                            ) : (
                              <div className='flex'>
                                <div className=' peer'>
                                  {renderStatus(serviceTaskData?.status)}
                                </div>
                                {(serviceTaskData.createdBy._id ===
                                  state.user._id ||
                                  serviceTaskData?.assignee._id ===
                                    state.user._id) &&
                                  serviceTaskData?.status !== "CANCELLED" &&
                                  serviceTaskData?.status !== "DONE" && (
                                    <div
                                      className='ml-1 mt-0 opacity-0 peer-hover:opacity-100 hover:opacity-100 duration-300'
                                      onClick={(e) => {
                                        setEditComponent("taskStatus");
                                      }}>
                                      <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        className='h-6 w-6'
                                        viewBox='0 0 20 20'
                                        fill='currentColor'>
                                        <path d='M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z' />
                                      </svg>
                                    </div>
                                  )}
                              </div>
                            )
                          ) : (
                            <span className='mt-1 block w-full py-0 sm:text-base'>
                              <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                                <div className='w-56 bg-gray-100 h-6 rounded-md '></div>
                              </div>
                            </span>
                          )}
                        </div>
                        <div className='col-span-6 sm:col-span-3'>
                          <label
                            htmlFor='assigneeId'
                            className='block text-sm font-medium text-gray-700'>
                            Reported By
                          </label>
                          {serviceTaskData?._id ? (
                            <span className='mt-1 ml-2 block w-full py-0 sm:text-base'>
                              <div className='flex justify-start h-full justify-left'>
                                <div className='font-semibold text-base py-0.5 px-2 bg-gray-100 rounded-md leading-5'>
                                  <div className='flex'>
                                    <div className='p-2 justify-between'>
                                      <img
                                        src={
                                          serviceTaskData?.createdBy?.avatar
                                            ? serviceTaskData?.createdBy?.avatar
                                            : "/assets/images/user.png"
                                        }
                                        alt='User'
                                        referrerPolicy='no-referrer'
                                        className='h-6 w-6 rounded-full ring-1 ring-yellow-2'
                                      />
                                    </div>
                                    <div className='flex flex-col p-2 pt-1'>
                                      <h2 className='font-semibold text-xs'>
                                        {serviceTaskData?.createdBy?.fullname
                                          ? serviceTaskData?.createdBy?.fullname
                                          : serviceTaskData?.createdBy
                                              ?.firstname}
                                      </h2>
                                      <h2 className='font-semibold text-xs'>
                                        {serviceTaskData?.createdBy?.phone}
                                      </h2>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </span>
                          ) : (
                            <span className='mt-1 block w-full py-0 sm:text-base'>
                              <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                                <div className='w-56 bg-gray-100 h-6 rounded-md '></div>
                              </div>
                            </span>
                          )}
                        </div>

                        <div className='col-span-12 sm:col-span-10'>
                          <label
                            htmlFor='taskDescription'
                            className='block text-sm font-semibold text-gray'>
                            Task Description
                          </label>
                          {serviceTaskData?._id ? (
                            editComponent === "taskDescription" ? (
                              <textarea
                                id='taskDescription'
                                name='taskDescription'
                                onBlur={(e) => {
                                  if (editComponent !== "")
                                    updateDetails(
                                      "description",
                                      "taskDescription",
                                    );
                                }}
                                rows={4}
                                className='shadow-sm focus:ring-yellow-2 focus:border-yellow-2 mt-1 block w-full sm:text-sm border bg-gray-50 rounded-md'
                                placeholder=''
                                defaultValue={serviceTaskData.description}
                              />
                            ) : (
                              <span className='mt-0 ml-4 flex w-full py-0 sm:text-base'>
                                <div className=' h-full peer'>
                                  <div className='font-normal text-sm py-1 pr-6 text-justify leading-5'>
                                    {serviceTaskData.description}
                                  </div>
                                </div>
                                {serviceTaskData.createdBy._id ===
                                  state.user._id && (
                                  <div
                                    className='ml-1 mt-0 opacity-0 peer-hover:opacity-100 hover:opacity-100 duration-300'
                                    onClick={(e) => {
                                      setEditComponent("taskDescription");
                                    }}>
                                    <svg
                                      xmlns='http://www.w3.org/2000/svg'
                                      className='h-6 w-6'
                                      viewBox='0 0 20 20'
                                      fill='currentColor'>
                                      <path d='M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z' />
                                    </svg>
                                  </div>
                                )}
                              </span>
                            )
                          ) : (
                            <span className='mt-1 block w-full py-0 sm:text-base'>
                              <div className='flex animate-pulse flex-row items-center h-full justify-left'>
                                <div className='w-full bg-gray-100 h-12 rounded-md '></div>
                              </div>
                            </span>
                          )}
                        </div>
                        <div className='mt-0 sm:mt-4 block sm:w-6/12 w-full col-span-12'>
                          <div className='bg-yellow-50 rounded p-4 pt-3'>
                            <div className='flex justify-between'>
                              <span className='block text-base font-semibold text-gray-dark mt-1 ml-0.5'>
                                CheckList
                              </span>
                              <Link to='#'>
                                <button
                                  type='button'
                                  onClick={(e) => {
                                    setShowChecklistForm(!showChecklistForm);
                                  }}
                                  className='inline-flex items-center px-3 py-1.5 rounded-sm text-sm font-medium text-white bg-yellow-2 hover:bg-gray-dark hover:text-white focus:outline-none duration-300'>
                                  New Checkpoint
                                </button>
                              </Link>
                            </div>
                            {showChecklistForm && (
                              <div className='flex px-2 justify-items-center'>
                                <div className='w-9/12'>
                                  <input
                                    type='text'
                                    name='checklistName'
                                    id='checklistName'
                                    maxLength='150'
                                    placeholder='Checklist Name'
                                    className={`mt-5 ${
                                      !validChecklistName
                                        ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                        : "focus:ring-yellow-2 focus:border-yellow-2"
                                    }  block w-full shadow-sm sm:text-sm  rounded-sm`}
                                  />
                                  {!validChecklistName && (
                                    <p className='text-red-600 text-sm'>
                                      Checklist Name invalid
                                    </p>
                                  )}
                                </div>
                                <div className='w-3/12'>
                                  {!requestLoading ? (
                                    <button
                                      type='button'
                                      onClick={(e) => {
                                        addChecklist();
                                      }}
                                      className='inline-flex items-center px-6 py-2 rounded-sm text-sm font-medium text-white bg-yellow-2 hover:bg-gray-dark hover:text-white focus:outline-none ml-2 mt-5'>
                                      Add
                                    </button>
                                  ) : (
                                    <button
                                      className='animate-bounce inline-flex items-center px-6 py-2 rounded-sm text-sm font-medium text-white bg-yellow-2 hover:bg-gray-dark hover:text-white focus:outline-none ml-2 mt-5'
                                      disabled={true}>
                                      Processing...
                                    </button>
                                  )}
                                </div>
                              </div>
                            )}
                            {serviceTaskData._id ? (
                              <div className='flex-row '>
                                <div className='mt-4'>
                                  {taskChecklistData.length > 0 ? (
                                    taskChecklistData.map((item) => (
                                      <div
                                        key={item._id}
                                        className='grid grid-cols-12 gap-2 my-2 px-4 py-2 w-full bg-yellow-3 hover:bg-gray-700 rounded-md hover:text-white duration-300 cursor-pointer'>
                                        <div className='col-span-8 font-semibold text-sm pt-0.5'>
                                          {item.name}
                                        </div>
                                        {item?.completionPercentage !== 100 ? (
                                          <div className=''>
                                            {item?.completionPercentage}%
                                          </div>
                                        ) : (
                                          <div className='col-span-2'>
                                            <span className='bg-green-100 text-green-800 text-xs -mt-1 font-semibold mr-2 px-2.5 py-0.5 rounded-sm dark:bg-green-200 dark:text-green-900'>
                                              COMPLETED
                                            </span>
                                          </div>
                                        )}
                                        {item?.completionPercentage !== 100 && (
                                          <div
                                            className='col-span-1'
                                            title='Mark as Complete'>
                                            <div className='flex mt-0'>
                                              <label className='ml-7 relative items-center cursor-pointer'>
                                                <input
                                                  type='checkbox'
                                                  className='sr-only peer '
                                                  checked={
                                                    completeCheckPointId ===
                                                    item?._id
                                                      ? true
                                                      : false
                                                  }
                                                  readOnly
                                                />
                                                <div
                                                  onClick={() => {
                                                    setCompleteCheckPointId(
                                                      item?._id,
                                                    );
                                                    markCheckpointComplete(
                                                      item?._id,
                                                    );
                                                  }}
                                                  className=" w-11 h-6 bg-gray-200 rounded-full peer  peer-focus:ring-yellow-50  peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-yellow-dark"></div>
                                              </label>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    ))
                                  ) : (
                                    <div className='font-semibold ml-7 mt-1'>
                                      <span className=''>
                                        No active checklist for this task
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </div>
                            ) : (
                              <span className='mt-1 block w-full py-0 pl-2 sm:text-base'>
                                <div className='flex animate-pulse flex-col h-full '>
                                  <div className='w-full mt-2 bg-gray-50 h-10 rounded-md '></div>
                                  <div className='w-full mt-2 bg-gray-50 h-10 rounded-md '></div>
                                  <div className='w-full mt-2 bg-gray-50 h-10 rounded-md '></div>
                                  <div className='w-full mt-2 bg-gray-50 h-10 rounded-md '></div>
                                  <div className='w-full mt-2 bg-gray-50 h-10 rounded-md '></div>
                                </div>
                              </span>
                            )}
                          </div>
                        </div>
                        <div className='col-span-12 sm:col-span-10'>
                          <h2 className='text-lg font-semibold leading-3 text-gray-dark sm:mt-4 mt-0'>
                            Activity
                          </h2>
                          <div className='my-2 p-0 pt-1 pb-0 flex'>
                            <div className='p-1'>
                              {serviceTaskData?.validflag === 1 &&
                                (serviceTaskData?.serviceTaskID ? (
                                  <img
                                    src={
                                      state?.user?.avatar
                                        ? state?.user?.avatar
                                        : "/assets/images/user.png"
                                    }
                                    alt='User'
                                    referrerPolicy='no-referrer'
                                    className='h-8 w-8 rounded-full '
                                  />
                                ) : (
                                  <div className='animate-pulse w-8 bg-gray-300 h-8 rounded-full'></div>
                                ))}
                            </div>
                            {serviceTaskData?.validflag === 1 &&
                              (serviceTaskData?.serviceTaskID ? (
                                <div className='flex-row overflow-x-auto px-3 rounded-lg py-3 bg-gray-100 w-11/12'>
                                  <form
                                    action='#'
                                    method='POST'
                                    id='taskCommentForm'
                                    noValidate
                                    onSubmit={(event) => {
                                      event.preventDefault();
                                      postComment(event);
                                    }}>
                                    <div className='text-sm font-semibold py-0.25 text-blue-800 '>
                                      <input
                                        type='text'
                                        name='commentTags'
                                        id='commentTags'
                                        maxLength='50'
                                        placeholder='Tags can be split using spacebar'
                                        className={`mt-0 focus:ring-yellow-2 focus:border-yellow-2 block sm:w-6/12 w-full shadow-sm text-xs border-0 bg-yellow-50 py-1 px-2 rounded-sm`}
                                      />
                                    </div>
                                    <textarea
                                      name='commentDescription'
                                      id='commentDescription'
                                      rows={4}
                                      placeholder='Write Comments here..'
                                      className={`mt-1 w-full border-0 bg-gray-50 ${
                                        !validCommentDescription
                                          ? "border ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                          : "focus:ring-yellow-2 focus:border-yellow-2"
                                      }  block shadow-sm sm:text-sm  rounded-md`}
                                    />
                                    {!validCommentDescription && (
                                      <p className='text-red-600 text-sm font-semibold'>
                                        Comment invalid
                                      </p>
                                    )}
                                    <div className='flex'>
                                      {commentAttachments.length > 0 ? (
                                        commentAttachments.map((item) => (
                                          <div
                                            key={item.filename}
                                            className='my-2 mr-1 px-1.5 py-1 pt-0.5 bg-white rounded z-0'>
                                            <div className='flex'>
                                              <div className='font-semibold text-xs text-yellow-dark mt-1'>
                                                {item.originalname}
                                              </div>
                                              <div
                                                className='ml-2 pt-1 cursor-pointer'
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  removeCommentAttachment(
                                                    item.originalname,
                                                  );
                                                }}>
                                                <img
                                                  className={`h-4 w-4`}
                                                  src='/assets/icons/trash-filled.png'
                                                  alt='X'
                                                  title='Remove attachment'
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        ))
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                    <div className=''>
                                      {isFileUploading ? (
                                        <div className='rounded w-full h-16 mt-1 border-dotted border-4 border-yellow-dark flex justify-center items-center cursor-pointer animate-bounce opacity-60'>
                                          <p className='p-3'>
                                            File Uploading to Server...
                                          </p>
                                        </div>
                                      ) : (
                                        <FileUploader
                                          handleChange={
                                            uploadCommentAttachments
                                          }
                                          name='attachments'
                                          multiple={true}
                                          label='Upload or Drop files to move enquiry to Service ticket'
                                          children={
                                            <div className='rounded w-full h-16 mt-1 border-dotted border-4 border-yellow-dark flex justify-center items-center cursor-pointer'>
                                              <p className='p-3'>
                                                Drag &amp; Drop files here
                                              </p>
                                            </div>
                                          }
                                          types={["JPG", "PNG", "PDF", "TXT"]}
                                        />
                                      )}
                                    </div>
                                    <div className='ml-0 pb-1'>
                                      {!requestLoading ? (
                                        <button
                                          id='submitBtn'
                                          type='submit'
                                          className='mt-2 inline-flex justify-center py-2 px-4 border-transparent shadow-sm text-sm font-medium rounded-sm text-white bg-yellow-2 hover:bg-gray-dark duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                                          Add Activity
                                        </button>
                                      ) : (
                                        <button
                                          className='animate-bounce mt-2 inline-flex justify-center py-2 px-4 border-transparent shadow-sm text-sm font-medium rounded-sm text-white bg-yellow-2  duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'
                                          disabled={true}>
                                          Processing...
                                        </button>
                                      )}
                                    </div>
                                  </form>
                                </div>
                              ) : (
                                <span className='mt-1 block w-full py-0 pl-2 sm:text-base'>
                                  <div className='flex animate-pulse flex-col h-full '>
                                    <div className='w-6/12 bg-yellow-50 h-6 rounded-md '></div>
                                    <div className='mt-3 w-10/12 bg-gray-100 h-20 rounded-md '></div>
                                    <div className='mt-3 w-32 bg-yellow-2 h-12 rounded-md '></div>
                                  </div>
                                </span>
                              ))}
                          </div>
                          <div className='mt-1 '>
                            {serviceTaskData?.serviceTaskID ? (
                              taskCommentsData?.length > 0 ? (
                                taskCommentsData.map((item) => (
                                  <div className='flex-col'>
                                    <div
                                      key={item._id}
                                      className='mt-2 p-2 pt-1 pb-0 flex justify-start'>
                                      <div className='flex-row overflow-x-auto pl-2 pr-5 rounded-lg py-2 bg-gray-300 peer'>
                                        <div className='flex'>
                                          <img
                                            src={
                                              item?.createdBy?.avatar
                                                ? item?.createdBy?.avatar
                                                : "/assets/images/user.png"
                                            }
                                            alt='User'
                                            referrerPolicy='no-referrer'
                                            className='h-6 w-6 rounded-full '
                                          />
                                          <div className='ml-1 mt-0.5 text-sm font-semibold'>
                                            {item.createdBy.firstname} &bull;{" "}
                                            {format(
                                              new Date(item.createdAt),
                                              "MMM dd yyyy, hh:mm a",
                                            )}
                                          </div>
                                        </div>
                                        <div className='text-xs font-semibold pt-1 pb-0.25 text-blue-800 mt-1'>
                                          <p className='text-shadow'>
                                            {item.tags && item.tags !== ""
                                              ? renderTags(item.tags)
                                              : item.commentType !==
                                                "user-comment"
                                              ? renderTags(item.commentType)
                                              : ""}
                                          </p>
                                        </div>
                                        <div
                                          className='text-sm'
                                          dangerouslySetInnerHTML={{
                                            __html: item.description,
                                          }}></div>
                                      </div>
                                      {state.user._id === item.createdBy._id &&
                                        item.commentType === "user-comment" &&
                                        moment(item?.createdAt).diff(
                                          Date.now(),
                                          "minutes",
                                        ) > -10 && (
                                          <div className='peer-hover:opacity-100 opacity-0 hover:opacity-100'>
                                            <div
                                              className='mt-0 ml-1 p-0.5 rounded bg-yellow-dark cursor-pointer'
                                              onClick={(e) => {
                                                e.preventDefault();
                                                removeActivity(item._id);
                                              }}>
                                              <img
                                                className={`h-5 w-5`}
                                                src='/assets/icons/trash-filled.png'
                                                alt='Delete'
                                                title='Delete Activity'
                                              />
                                            </div>
                                          </div>
                                        )}
                                    </div>
                                    <div className='flex'>
                                      {item.attachments?.length > 0 ? (
                                        item.attachments.map((item) => (
                                          <div
                                            key={item.blobName}
                                            className={`ml-1.5 text-xs px-1.5 pt-0.5 pb-1 bg-yellow-50 rounded-md z-0 ${
                                              item.blobName ===
                                              downloadBlobFileName
                                                ? "animate-pulse cursor-wait"
                                                : "cursor-pointer"
                                            } `}
                                            onClick={(e) => {
                                              downloadAttachment(
                                                item.blobContainer,
                                                item.blobName,
                                                item.originalname,
                                                item.mimetype,
                                              );
                                            }}>
                                            <div className='flex'>
                                              <div className='font-semibold text-yellow-dark'>
                                                {item.originalname}
                                              </div>
                                            </div>
                                          </div>
                                        ))
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  </div>
                                ))
                              ) : (
                                <div className='w-full grid justify-items-center font-semibold mt-4 text-base'>
                                  No Activity yet
                                </div>
                              )
                            ) : (
                              <span className='mt-4 block w-full py-0 pl-5 sm:text-base'>
                                <div className='flex animate-pulse flex-col h-full '>
                                  <div className='w-10/12 bg-gray-100 h-12 rounded-md '></div>
                                  <div className='mt-3 w-10/12 bg-gray-100 h-12 rounded-md '></div>
                                  <div className='mt-3 w-10/12 bg-gray-100 h-12 rounded-md '></div>
                                  <div className='mt-3 w-10/12 bg-gray-100 h-12 rounded-md '></div>
                                </div>
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='px-4 py-3 bg-gray-50 text-right sm:px-6'>
                    <div className='lg:flex lg:items-center justify-between'>
                      <div className='flex-1 min-w-0 px-0 lg:px-0'>
                        <Link
                          to='#'
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(-1);
                          }}
                          className='inline-flex justify-center py-2 px-4 border-yellow-2 border shadow-sm text-sm font-medium rounded-sm text-yellow-2 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                          Back
                        </Link>
                      </div>
                    </div>
                    <div className='sm: py-2'></div>
                  </div>
                </div>
              </div>
              <div className='block md:hidden'>
                <div className='grid grid-cols-1 gap-4'></div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default ServiceTicketViewSpecific;
